import { z } from 'zod';

import {
  BackgroundColor,
  JustifyContent,
  ImageSize,
  FlexDirection,
  ContainerType,
  CmsImage,
  PaddingStyle,
} from '../models';
import { BasePType } from './base';
import { FlexboxItem } from './flexbox-item';
import { Image } from './image';

const baseFlexboxContentContainer = BasePType.extend({
  type: z.enum(['flexboxContentContainer']),
  bgColor: z.nullable(BackgroundColor),
  bottomBorder: z.boolean(),
  containerType: z.nullable(ContainerType),
  flexCenter: z.boolean(),
  flexDirection: z.nullable(FlexDirection),
  flexVcenter: z.boolean(),
  fullWidthBackground: z.boolean(),
  height: z.number().nullable(),
  image: z.array(Image).optional(),
  imageSize: z.nullable(ImageSize),
  justifyContent: z.nullable(JustifyContent),
  leftBorder: z.boolean(),
  paddingBottom: z.nullable(PaddingStyle),
  paddingBottomDesktop: z.nullable(PaddingStyle),
  paddingBottomMidrange: z.nullable(PaddingStyle),
  paddingTop: z.nullable(PaddingStyle),
  paddingTopDesktop: z.nullable(PaddingStyle),
  paddingTopMidrange: z.nullable(PaddingStyle),
  paddingVertical: z.nullable(PaddingStyle),
  paddingVerticalDesktop: z.nullable(PaddingStyle),
  paddingVerticalMidrange: z.nullable(PaddingStyle),
  roundedCorner: z.string().nullable(),
  webpMedia: z.array(CmsImage).optional().nullable(),
  constrainContentWidth: z.boolean().nullable().optional(),
});

export type FlexboxContentContainer = z.infer<
  typeof baseFlexboxContentContainer
> & {
  nestedFlexboxItem?: FlexboxItem[];
};

export const FlexboxContentContainer: z.ZodType<FlexboxContentContainer> =
  baseFlexboxContentContainer.extend({
    nestedFlexboxItem: z.lazy(() => z.array(FlexboxItem)).optional(),
  });
